import React from 'react';
import { Text } from '@usealloy/component-library';
import { ColumnBox, GrayLabel } from '../styles';

interface ColumnBoxWithGrayLabelProps {
  label: string;
  text?: string;
  children?: React.ReactNode;
}

export const ColumnBoxWithGrayLabel = ({
  label, text, children,
}: ColumnBoxWithGrayLabelProps) => (
  <ColumnBox>
    <GrayLabel style={{
      textTransform: 'capitalize',
    }}
    >
      {label}
    </GrayLabel>
    {text && <Text>{text}</Text>}
    {!text && children}
  </ColumnBox>
);
